import React from "react";
import {
  MapPin,
  Users,
  Store,
  Building,
  Package,
  ShieldCheck,
  Truck,
  ClipboardList,
  Boxes,
} from "lucide-react";

const Dccws = () => {
  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (!element) return;

    const yOffset = -120;
    const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;

    window.scrollTo({ top: y, behavior: "smooth" });
  };
const [activePopup, setActivePopup] = React.useState(null);

  return (
    <div className="min-h-screen font-sans flex">

      {/* ---------------- LEFT FIXED MENU ---------------- */}
      <div className="w-72 pt-28">
        <div className="bg-white shadow-sm border border-gray-200 p-6 sticky top-24 font-sans">
          <h3 className="text-2xl font-bold text-gray-900 mb-4 pb-3 border-b">
            Departments
          </h3>

          <div className="text-sm text-gray-800 space-y-4">

            <div className="font-semibold text-gray-900 text-lg">
              Consumer Cooperative
            </div>

            {/* DCCWS */}
            <details className="group">
              <summary className="flex justify-between items-center cursor-pointer text-sm font-medium text-gray-800 list-none">
                <button
                  onClick={() => scrollToSection("dccws-heading")}
                  className="text-left font-medium hover:text-blue-600 hover:underline text-lg"
                >
                  DCCWS
                </button>

                <span className="transition-transform group-open:rotate-180 text-gray-500">▼</span>
              </summary>

              <div className="mt-2 pl-4 space-y-2 text-sm text-blue-600">
                <button onClick={() => scrollToSection("dccws-overview")} className="block text-left hover:underline text-base">
                  Overview
                </button>
                <button onClick={() => scrollToSection("dccws-functionality")} className="block text-left hover:underline text-base">
                  Key Functionality
                </button>
                <button
  onClick={() => scrollToSection("dccws-services")}
  className="block text-left hover:underline text-base"
>
  Services Offered
</button>

                <button onClick={() => scrollToSection("dccws-stats")} className="block text-left hover:underline text-base">
                  Key Stats
                </button>
              </div>
            </details>

            {/* Primary Stores */}
            <details className="group">
              <summary className="flex justify-between items-center cursor-pointer text-sm font-medium text-gray-800 list-none">
                <button
                  onClick={() => scrollToSection("primary-heading")}
                  className="text-left font-medium hover:text-blue-600 hover:underline text-lg"
                >
                  Primary Stores
                </button>

                <span className="transition-transform group-open:rotate-180 text-gray-500">▼</span>
              </summary>

              <div className="mt-2 pl-4 space-y-2 text-sm text-blue-600">
                <button onClick={() => scrollToSection("primary-overview")} className="block text-left hover:underline text-base">
                  Overview
                </button>
                <button onClick={() => scrollToSection("primary-functionality")} className="block text-left hover:underline text-base">
                  Key Functionality
                </button>
                <button onClick={() => scrollToSection("primary-stats")} className="block text-left hover:underline text-base">
                  Key Stats
                </button>
              </div>
            </details>
          </div>
        </div>
      </div>

      {/* ---------------- RIGHT CONTENT ---------------- */}
      <div className="flex-1 overflow-y-auto bg-gray-100">
        <header className="text-center py-10 bg-white border-b -mb-2">
          <h1 className="text-4xl font-bold text-gray-800 text-left">CONSUMER COOPERATIVES</h1>
        </header>

        {/* ===== DCCWS SECTION ===== */}
        <section id="dccws-section" className="w-full">

          {/* Gradient Header */}
          <header id="dccws-heading" className="text-center py-10 ">
            <h1 className="text-4xl font-bold text-gray-800">DCCWS</h1>
          </header>

          {/* OVERVIEW */}
          <div id="dccws-overview" className="px-6 lg:px-16 py-10">
            <div className="bg-white shadow-sm p-6 rounded-xl border-l-4 border-blue-500">
              <h2 className="text-xl font-semibold mb-3 text-gray-900">Overview</h2>
              <p className="text-gray-700 text-base leading-relaxed">
                District Central Cooperative Wholesale Stores (DCCWs) serve as the backbone of Tamil Nadu’s cooperative distribution network. They ensure uninterrupted supply of essential commodities to fair price shops, primary stores, and other cooperatives across the district. By managing procurement, storage, and bulk distribution efficiently, DCCWs play a key role in price stability, timely availability, and transparent service delivery to citizens.
              </p>
            </div>
          </div>

          {/* FUNCTIONALITY */}
          <div id="dccws-functionality" className="px-6 lg:px-16 pb-10 bg-white pt-5">
            <h3 className="text-xl font-semibold mb-4 text-gray-800">Key Functionality</h3>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
              {[
                { icon: <Package />, text: "Bulk procurement of essential commodities" },
                { icon: <Truck />, text: "Distribution to Fair Price Shops & Primary Cooperatives" },
                { icon: <ShieldCheck />, text: "Quality control and stock monitoring" },
                { icon: <Boxes />, text: "Warehousing and safe storage" },
                { icon: <ClipboardList />, text: "Coordination with TNCSC, Civil Supplies & PDS" },
                { icon: <Store />, text: "Ensuring on-time replenishment" },
              ].map((item, i) => (
                <div key={i} className="bg-white shadow p-5 rounded-xl flex gap-4 items-start border border-gray-100">
                  <div className="bg-blue-50 p-3 rounded-lg text-blue-600">
                    {item.icon}
                  </div>
                  <p className="text-base text-gray-700">{item.text}</p>
                </div>
              ))}
            </div>
          </div>
<div
  id="dccws-services"
  className="px-6 lg:px-16 pb-10 bg-gray-100 pt-10"
>

  <h3 className="text-xl font-semibold mb-4 text-gray-800">
    Services Offered
  </h3>

  <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">

    {/* 1. Deposit Collection */}
    <div className="bg-blue-50 shadow p-6 rounded-xl border border-blue-100">
      <h4 className="text-lg font-semibold text-gray-900 mb-2">
        Deposit Collection
      </h4>
      <p className="text-gray-600 text-sm">
        Mobilizing public deposits through cooperative banking channels
      </p>
    </div>

    {/* 2. Cash Credit */}
    <div className="bg-indigo-50 shadow p-6 rounded-xl border border-indigo-100">
      <h4 className="text-lg font-semibold text-gray-900 mb-2">
        Cash Credit to PACCS, ECS, CMS, CWS
      </h4>
      <p className="text-gray-600 text-sm">
        Providing working capital support to cooperative institutions
      </p>
    </div>

    {/* 3. Providing Loans (POPUP) */}
    <div
      onClick={() => setActivePopup("loans")}
      className="cursor-pointer bg-emerald-50 shadow p-6 rounded-xl border border-emerald-200 hover:border-emerald-400 transition"
    >
      <h4 className="text-lg font-semibold text-gray-900 mb-2">
        Providing Loans
      </h4>
      <p className="text-gray-600 text-sm">
        Click to view loan schemes & beneficiaries
      </p>
    </div>

    {/* 4. Safety Locker */}
    <div className="bg-amber-50 shadow p-6 rounded-xl border border-amber-100">
      <h4 className="text-lg font-semibold text-gray-900 mb-2">
        Providing Safety Locker Facility
      </h4>
      <p className="text-gray-600 text-sm">
        Secure locker facilities for customers
      </p>
    </div>

    {/* 5. Modern Banking (POPUP) */}
    <div
      onClick={() => setActivePopup("banking")}
      className="cursor-pointer bg-sky-50 shadow p-6 rounded-xl border border-sky-200 hover:border-sky-400 transition"
    >
      <h4 className="text-lg font-semibold text-gray-900 mb-2">
        Offering Modern Banking Facilities
      </h4>
      <p className="text-gray-600 text-sm">
        Click to view digital & electronic banking services
      </p>
    </div>

  </div>
</div>


       {/* STATS */}
<div id="dccws-stats" className="px-6 lg:px-16 pb-12 mt-5">
  <h3 className="text-xl font-semibold mb-4 text-gray-800">Key Financial Highlights</h3>

  <div className="bg-blue-500 rounded-xl p-6 flex flex-wrap gap-4 justify-between text-white">
    {[
      {
        title: "₹ 2,435.32 Cr",
        subtitle: "Share Capital",
        icon: <Building />,
      },
      {
        title: "₹ 43,161.35 Cr",
        subtitle: "Deposit Outstanding",
        icon: <Users />,
      },
      {
        title: "₹ 60,073.18 Cr",
        subtitle: "Loan Outstanding",
        icon: <Store />,
      },
      {
        title: "24 DCCBs",
        subtitle: "All Functioning with Net Profit",
        icon: <MapPin />,
      },
    ].map((item, i) => (
      <div
        key={i}
        className="flex-1 min-w-[200px] bg-white/20 backdrop-blur rounded-lg p-4 flex items-center gap-4"
      >
        <div className="bg-white text-blue-600 p-3 rounded-full">
          {item.icon}
        </div>
        <div>
          <div className="text-2xl font-bold">{item.title}</div>
          <div className="text-sm font-semibold opacity-90">
            {item.subtitle}
          </div>
        </div>
      </div>
    ))}
  </div>

  <div className="mt-6 text-center -mb-10">
    <span className="inline-block bg-blue-100 text-blue-700 px-6 py-3 rounded-full text-base font-semibold">
      All 24 District Central Cooperative Banks are operating profitably
    </span>
  </div>
</div>

        </section>

        {/* PRIMARY STORES SECTION */}
        <section id="primary-section" className="w-full ">

          <header id="primary-heading" className="text-center py-10 ">
            <h1 className="text-4xl font-bold text-gray-800 bg-white pt-5 pb-5">PRIMARY STORES</h1>
          </header>

          {/* OVERVIEW */}
          <div id="primary-overview" className="px-6 lg:px-16 py-10">
            <div className="bg-white shadow-sm p-6 rounded-xl border-l-4 border-blue-500">
              <h2 className="text-xl font-semibold mb-3 text-gray-900">Overview</h2>
              <p className="text-gray-700 text-base leading-relaxed">
                Primary Cooperative Stores bring essential commodities and everyday household goods directly to communities through a trusted and affordable cooperative retail system. Operating at the grassroots level, these stores ensure access to quality products, fair pricing, and reliable service—especially for rural and semi-urban families. As the last-mile link in the cooperative chain, they play a vital role in supporting household budgets and strengthening community welfare.
              </p>
            </div>
          </div>

          {/* KEY FUNCTIONS */}
          <div id="primary-functionality" className="px-6 lg:px-16 pb-10 bg-white pt-5">
            <h3 className="text-xl font-semibold mb-4 text-gray-800">Key Functions</h3>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
              {[
                "Fair & transparent pricing",
                "Quality-assured products",
                "Community-oriented services",
                "Regular stock replenishment",
                "Support to local producers",
              ].map((text, i) => (
                <div key={i} className="bg-white shadow p-5 rounded-xl flex gap-3 items-start border border-gray-100">
                  <div className="bg-blue-50 p-2 rounded text-blue-600">
                    <Store size={20} />
                  </div>
                  <p className="text-base text-gray-700">{text}</p>
                </div>
              ))}
            </div>
          </div>

          {/* STATS */}
          <div id="primary-stats" className="px-6 lg:px-16 pb-12 pt-5">
            <h3 className="text-xl font-semibold mb-4 text-gray-800">Key Stats</h3>

            <div className="bg-blue-500 rounded-xl p-6 flex flex-wrap gap-4 justify-between text-white">
              {[
                { title: "1000+", subtitle: "Primary Stores", icon: <Store /> },
                { title: "100%", subtitle: "Rural & Urban Coverage", icon: <Users /> },
                { title: "24/7", subtitle: "Customer Service", icon: <MapPin /> },
              ].map((item, i) => (
                <div key={i} className="flex-1 min-w-[200px] bg-white/20 backdrop-blur rounded-lg p-4 flex items-center gap-4">
                  <div className="bg-white text-blue-600 p-3 rounded-full">
                    {item.icon}
                  </div>
                  <div>
                    <div className="text-2xl font-bold">{item.title}</div>
                    <div className="text-sm font-semibold opacity-90">{item.subtitle}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>
      </div>
  {activePopup && (
  <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 backdrop-blur-sm">
    
    <div className="bg-white rounded-2xl w-full max-w-4xl h-[75vh] shadow-2xl flex flex-col animate-fadeIn">

      {/* HEADER */}
      <div className="flex items-center justify-between px-6 py-4 border-b sticky top-0 bg-white rounded-t-2xl z-10">
        <h3 className="text-xl font-semibold text-gray-800">
          {activePopup === "loans"
            ? "Loan Services"
            : "Modern Banking Facilities"}
        </h3>

        <button
          onClick={() => setActivePopup(null)}
          className="w-9 h-9 flex items-center justify-center rounded-full bg-gray-100 hover:bg-gray-200 text-gray-600 hover:text-gray-800 transition"
        >
          ✕
        </button>
      </div>

      {/* CONTENT */}
      <div className="flex-1 overflow-y-auto px-6 py-5">
        
        {/* LOANS */}
        {activePopup === "loans" && (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
            {[
              "Differently Abled Loan",
              "DW & DW",
              "Education Loan",
              "House Appliances Loan",
              "Housing & House Mortgage Loan",
              "Jewel Loan",
              "Kalaignarin Kanavu Illam Scheme Loan",
              "E-Auto Loan for Economically Backward Women",
              "Loans to FPOs, SHGs & JLGs",
              "Loans to Landless Poor Women (Agri Land)",
              "Loans to Folk Artistes",
              "Medium Term Loan",
              "MSME Loan",
              "NFS Loan",
              "Petty Traders Loan",
              "Plot Purchase Loan",
              "Reverse Mortgage Loan",
              "Self Help Groups Loan",
              "Siragugal Scheme Loan",
              "TABCEDCO / TAHDCO / TAMCO Loans",
              "Vehicle Loan",
              "Women Entrepreneurs Loan",
              "Working Women Loan",
              "NEEDS",
              "AABCS",
            ].map((item, i) => (
              <div
                key={i}
                className="bg-blue-50/50 border border-blue-100 rounded-lg px-4 py-3 text-sm text-gray-700 hover:bg-blue-50 transition"
              >
                {item}
              </div>
            ))}
          </div>
        )}

        {/* BANKING */}
        {activePopup === "banking" && (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
            {[
              "IMPS",
              "ATM Facilities",
              "Micro ATM Cards",
              "RUPAY Debit Cards",
              "UPI",
              "CTS",
              "AEPS",
              "RTGS",
              "NEFT",
              "AML System",
              "Mobile Banking",
              "QR Code Payments",
              "Safety Locker Facility",
              "Deposit Collection",
              "Cash Credit to PACCS, ECS, CMS, CWS",
            ].map((item, i) => (
              <div
                key={i}
                className="bg-green-50/50 border border-green-100 rounded-lg px-4 py-3 text-sm text-gray-700 hover:bg-green-50 transition"
              >
                {item}
              </div>
            ))}
          </div>
        )}
      </div>

      {/* FOOTER */}
      <div className="px-6 py-3 border-t bg-gray-50 text-right rounded-b-2xl">
        <button
          onClick={() => setActivePopup(null)}
          className="px-5 py-2 rounded-lg bg-blue-600 text-white text-sm font-medium hover:bg-blue-700 transition"
        >
          Close
        </button>
      </div>
    </div>
  </div>
)}


    </div>
  );
};

export default Dccws;
